import {ConfigService, ErrorsService, Tank, ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TankService extends StoreService<Tank> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Tank);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Tank>> {
    return this.http.get<ModelsList<Tank>>(this.config.apiVerUrl('/app/tanks'), {params: queryParams});
  }

  protected insert(values: Tank): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/tanks'), values);
  }

  public testSensor(values: Tank): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/tanks/test-sensor'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/tanks/${id}`));
  }

  protected update(id, values: Tank): Observable<Tank> {
    return this.http.put<Tank>(this.config.apiVerUrl(`/app/tanks/${id}`), values);
  }

}
